// Support older browsers
import 'babel/polyfill';

import 'common/js/csrf';
import 'webshop/js/menu';
import 'jqueryUI';



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/base.js
 **/